import { useIntl, defineMessages } from 'react-intl-next';
import React, { useCallback } from 'react';

import Heading from '@atlaskit/heading';
import Button from '@atlaskit/button';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { Box, xcss } from '@atlaskit/primitives';

import { ADMIN_BULK_PERMISSIONS } from '@confluence/named-routes';
import { Attribution, withErrorBoundary } from '@confluence/error-boundary';

// TODO (pleaton): Update these messages when content is final
const i18n = defineMessages({
	title: {
		id: 'bulk-permissions.space.title',
		defaultMessage: 'Add people to all spaces',
		description: 'Title text of the bulk permissions page',
	},
	description: {
		id: 'bulk-permissions.space.description',
		defaultMessage:
			'Quickly add (or remove) individual users or groups to all spaces on your Confluence site.',
		description: 'Description text of the bulk permissions page',
	},
	button: {
		id: 'bulk-permissions.space.button',
		defaultMessage: 'Choose a user or group',
		description: 'Button text to bulk permissions page',
	},
});

const containerStyles = xcss({
	paddingTop: 'space.150',
	paddingBottom: 'space.150',
});

const buttonStyle = xcss({
	marginTop: 'space.100',
});

const BulkSpacePermissionsButtonComponent = () => {
	const intl = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const handleClick = useCallback(() => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				actionSubject: 'button',
				action: 'clicked',
				actionSubjectId: 'bulkPermissionsEntry',
				source: 'defaultspaceperms',
			},
		}).fire();
	}, [createAnalyticsEvent]);
	return (
		<Box xcss={containerStyles}>
			<Heading size="large">{intl.formatMessage(i18n.title)}</Heading>
			{intl.formatMessage(i18n.description)}
			<br />
			<Box xcss={buttonStyle}>
				<Button href={ADMIN_BULK_PERMISSIONS.toUrl()} onClick={handleClick}>
					{intl.formatMessage(i18n.button)}
				</Button>
			</Box>
		</Box>
	);
};

export const BulkSpacePermissionsButton = withErrorBoundary({
	attribution: Attribution.PERMISSIONS_EXPERIENCE,
})(BulkSpacePermissionsButtonComponent);
